import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable, observable } from 'mobx';
import { NavigateFunction } from 'react-router-dom';

import { UpdatePasswordCollaboration } from '@/modules/recognition/application/collaborations/update-password.collaboration';
import { UrlUtils } from '@/shared/application/utils/url';
import { IsStrongPassword, Match, ObservableForm } from '@/shared/presentation/forms/BaseForm';
import { MicrofrontendViewModel } from '@/shared/presentation/Microfrontend.vm';

class ResetPassForm {
  @IsStrongPassword()
  newPassword = '';

  @Match((p) => p.newPassword, { message: 'As senhas não coincidem' })
  newPasswordConfirmation = '';
}

interface ResetPassDto {
  newPassword: string;
  newPasswordConfirmation: string;
  token: any;
}

@ViewModel()
export class ResetPassViewModel implements IReactiveModel {
  @observable form = new ObservableForm(ResetPassForm);
  @observable isSubmitting = false;
  @observable errorMessage = '';
  @observable disabledButotn = '';
  private navigate: NavigateFunction;

  constructor(
    private updatePasswordCollaboration: UpdatePasswordCollaboration,
    private microfrontendViewModel: MicrofrontendViewModel,
  ) {
    makeAutoObservable(this);
  }

  @action
  async onInit({ navigate }) {
    this.navigate = navigate;
  }

  @action
  async resetPass() {
    try {
      if (this.form.hasError) {
        return;
      }

      this.isSubmitting = true;
      this.errorMessage = '';

      const dto: ResetPassDto = {
        newPassword: this.form.values.newPassword,
        newPasswordConfirmation: this.form.values.newPasswordConfirmation,
        token: UrlUtils.getQueryParam('token'),
      };

      await this.updatePasswordCollaboration.run(dto);
      await this.microfrontendViewModel.identifyCurrentAccount();

      this.navigate('/');
    } catch (error) {
      console.error(error);
      this.errorMessage = 'Ocorreu um erro ao tentar resetar a senha.';
    } finally {
      this.isSubmitting = false;
    }
  }
}
